import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  Home, 
  Users, 
  Building, 
  UserCheck, 
  LogOut,
  Menu,
  X,
  Calendar
} from "lucide-react";

const Layout = ({ children, user, onLogout }) => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const navigation = [
    {
      name: "Dashboard",
      href: "/dashboard",
      icon: Home,
      show: true
    },
    {
      name: "Appointments",
      href: "/appointments",
      icon: Calendar,
      show: true
    },
    {
      name: "Clients",
      href: "/clients",
      icon: Users,
      show: true
    },
    {
      name: "Hotels", 
      href: "/hotels",
      icon: Building,
      show: user?.role === "admin"
    },
    {
      name: "Executives",
      href: "/executives", 
      icon: UserCheck,
      show: user?.role === "admin" || user?.role === "manager"
    }
  ];

  const handleLogout = () => {
    onLogout();
  };

  const getPageTitle = () => {
    const path = location.pathname;
    switch (path) {
      case "/dashboard":
        return "Dashboard";
      case "/appointments":
        return "Appointments Management";
      case "/clients":
        return "Client Management";
      case "/hotels":
        return "Hotels Management";
      case "/executives":
        return "Executives Management";
      default:
        return "Click Efficiency CRM";
    }
  };

  const getUserInitials = () => {
    if (!user?.name) return "U";
    return user.name
      .split(" ")
      .map(n => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="dashboard-layout">
      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-content">
          <div className="sidebar-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_exec-portal/artifacts/mw7twjvg_1Logo%20Click.png"
              alt="Click Efficiency"
            />
            <div className="sidebar-title">Click Efficiency</div>
          </div>
          
          <nav>
            <ul className="sidebar-nav">
              {navigation
                .filter(item => item.show)
                .map((item) => (
                  <li key={item.name} className="nav-item">
                    <Link
                      to={item.href}
                      className={`nav-link ${location.pathname === item.href ? 'active' : ''}`}
                      data-testid={`nav-${item.name.toLowerCase()}`}
                      onClick={() => setSidebarOpen(false)}
                    >
                      <item.icon className="nav-icon" />
                      {item.name}
                    </Link>
                  </li>
                ))}
            </ul>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        <header className="header">
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="btn-icon"
              style={{ display: "none" }}
              data-testid="mobile-menu-button"
            >
              {sidebarOpen ? <X size={20} /> : <Menu size={20} />}
            </button>
            <h1 className="header-title">{getPageTitle()}</h1>
          </div>
          
          <div className="header-actions">
            <div className="user-info">
              <div className="user-avatar" data-testid="user-avatar">
                {getUserInitials()}
              </div>
              <div className="user-details">
                <div className="user-name" data-testid="user-name">{user?.name}</div>
                <div className="user-role" data-testid="user-role">{user?.role}</div>
              </div>
            </div>
            <button
              onClick={handleLogout}
              className="btn-icon"
              title="Logout"
              data-testid="logout-button"
            >
              <LogOut size={20} />
            </button>
          </div>
        </header>

        {/* Content */}
        <main className="content">
          {children}
        </main>
      </div>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-5 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default Layout;